import { axiosApiInstance } from '@/api/axios'

const urlBase = '/api/public'

const state = {
  mainPageSliders: [],
  blogsForHomePage: [],
  topSellingProducts: [],
  ourClients: [],
  advantagesHomePage: [],
  homePageSections: {},
  homePageLoading: false
}

const getters = {
  mainPageSliders: (state) => state.mainPageSliders,
  blogsForHomePage: (state) => state.blogsForHomePage,
  topSellingProducts: (state) => state.topSellingProducts,
  ourClients: (state) => state.ourClients,
  advantagesHomePage: (state) => state.advantagesHomePage,
  homePageSections: (state) => state.homePageSections,
  homePageLoading: (state) => state.homePageLoading
}

const mutations = {
  SET_SLIDERS(state, payload) {
    state.mainPageSliders = payload
  },
  SET_BLOGS_FOR_HOMEPAGE(state, payload) {
    state.blogsForHomePage = payload
  },
  SET_TOP_SELLING_PRODUCTS(state, payload) {
    state.topSellingProducts = payload
  },
  SET_OUR_CLIENTS(state, payload) {
    state.ourClients = payload
  },
  SET_ADVANTAGES_HOMEPAGE(state, payload) {
    state.advantagesHomePage = payload
  },
  SET_HOMEPAGE_SECTIONS(state, payload) {
    state.homePageSections = payload
  },
  SET_HOMEPAGE_LOADING(state, payload) {
    state.homePageLoading = payload
  }
}

const actions = {
  fetchHomePageData({ commit }) {
    commit('SET_HOMEPAGE_LOADING', true)
    axiosApiInstance
      .get(`${urlBase}/get_homepage`)
      .then((res) => {
        const processText = (inputText) => {
          return inputText.replace(/\\'/g, '').split(/(\d+)/).filter(Boolean)
        }

        const advantages = res.data.advantages.map((data) => ({
          id: data.id,
          data: data.data,
          sort: data.sort,
          name_en: data.name_en,
          name_ru: data.name_ru,
          name_uz: data.name_uz,
          dataNum: processText(data.data.toString())[0]
            ? parseInt(processText(data.data.toString())[0])
            : null,
          dataAppend: processText(data.data.toString())[1]
            ? processText(data.data.toString())[1]
            : null
        }))

        commit('SET_SLIDERS', res.data.sliders)
        commit('SET_TOP_SELLING_PRODUCTS', res.data.top_selling)
        commit('SET_BLOGS_FOR_HOMEPAGE', res.data.blogs)
        commit('SET_HOMEPAGE_SECTIONS', res.data.homepage_sections)
        commit('SET_OUR_CLIENTS', res.data.clients)
        commit('SET_ADVANTAGES_HOMEPAGE', advantages)
      })
      .catch((err) => console.log(err))
      .finally(() => {
        setTimeout(() => {
          commit('SET_HOMEPAGE_LOADING', false)
        }, 500)
      })
  },

  fetchOurClients({ commit }) {
    axiosApiInstance
      .get(`${urlBase}/get_our_clients`)
      .then((res) => {
        commit('SET_OUR_CLIENTS', res.data)
      })
      .catch((err) => console.log(err))
  },

  fetchAdvantagesHomePage({ commit }) {
    axiosApiInstance
      .get(`${urlBase}/get_advantages`)
      .then((res) => {
        const processText = (inputText) => {
          return inputText.replace(/\\'/g, '').split(/(\d+)/).filter(Boolean)
        }

        const data = res.data.map((data) => ({
          id: data.id,
          data: data.data,
          sort: data.sort,
          name_en: data.name_en,
          name_ru: data.name_ru,
          name_uz: data.name_uz,
          dataNum: processText(data.data.toString())[0]
            ? parseInt(processText(data.data.toString())[0])
            : null,
          dataAppend: processText(data.data.toString())[1]
            ? processText(data.data.toString())[1]
            : null
        }))

        commit('SET_ADVANTAGES_HOMEPAGE', data)
      })
      .catch((err) => console.log(err))
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
